import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
// hooks
import { useDashboardsAPI } from 'hooks/useDashboardsAPI'
// components
import AddItemButton from './components/AddItemButton'
import DashboardWidgets from './components/DashboardWidgets'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import MainLayoutContainer from 'containers/MainLayout/index'
import DashboardSettingsDrawer from '../../Modals/DashboardSettingsModal'
import DashboardWidgetSettingsDrawer from 'components/Modals/WidgetSettingsModal'
// constants
import { Modals } from 'constants/modals'
// view components
import { AddDashboardButton } from 'components/CTAs'
// views
import { Container } from '@mui/material'
// store
import {
  setDashboardsData,
  updateCurrentDashboard,
  isDashboardEditSelector,
  currentDashboardSelector
} from 'store/reducers/dashboards'
// utils
import { orderBy } from 'lodash'

const Home: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = React.useState(false)

  const isEdit = useSelector(isDashboardEditSelector)
  const currentDashboard = useSelector(currentDashboardSelector)

  const { closeSnackbar } = useSnackbar()

  const { getDashboards, getDashboardItems } = useDashboardsAPI()

  const getDashboardsData = async () => {
    setIsLoading(true)

    const dashboards = await getDashboards()

    if (dashboards?.length) {
      dispatch(
        setDashboardsData({
          data: orderBy(dashboards, 'createdAt'),
          current: dashboards[0]
        })
      )
    }

    setIsLoading(false)
  }

  const setDashboardItems = async () => {
    setIsLoading(true)

    const widgets = await getDashboardItems(currentDashboard.id)

    dispatch(updateCurrentDashboard(orderBy(widgets, 'item.createdAt')))

    setIsLoading(false)
  }

  React.useEffect(() => {
    getDashboardsData()
  }, [])

  React.useEffect(() => {
    if (currentDashboard) {
      setDashboardItems()
    }
  }, [currentDashboard?.id])

  React.useEffect(() => {
    return () => {
      dispatch(setDashboardsData({ edit: false }))
      closeSnackbar('dashboardEdit')
    }
  }, [location.pathname])

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading} CTA={<AddDashboardButton />}>
        <Container maxWidth={false}>
          <DashboardWidgets />
          {isEdit && <AddItemButton />}
        </Container>

        <DashboardSettingsDrawer />
        <DashboardWidgetSettingsDrawer />
        <ConfirmDeleteModal header='Delete Dashboard' modalType={Modals.CONFIRM_DELETE_DASHBOARD_MODAL}>
          Are you sure you want to delete this dashboard?
        </ConfirmDeleteModal>
        <ConfirmDeleteModal header={'Delete Widget'} modalType={Modals.CONFIRM_DELETE_WIDGET_MODAL}>
          Are you sure you want to delete this widget?
        </ConfirmDeleteModal>
      </MainLayoutContainer>
    </>
  )
}

export default Home
